import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BilletPage } from './billet/billet.page';
import { LiquidationPage } from './liquidation/liquidation.page';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'billet',
        pathMatch: 'full',
      },
      {
        path: 'billet',
        component: BilletPage,
      },
      {
        path: 'billet/:code',
        component: BilletPage,
      },
      {
        path: 'liquidation',
        component: LiquidationPage,
      },
      {
        path: 'detran',
        loadChildren: () => import('./detran/detran.module').then((m) => m.DetranModule),   
      }  
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class PaymentRoutingModule {}
